import styles from './CarriersCarouselSection.module.scss';

import React from 'react';
import { Container } from 'reactstrap';

import { ScrollOverPack, TweenOne, FadeUp, FadeIn } from 'src/components/Animations';
import ButtonLink from 'src/components/ButtonLink';
import CarriersCarousel from 'src/components/CarriersCarousel';

export default (props) => (
  <ScrollOverPack {...props}
                  className={props.className}
                  styleName='carriers-carousel-section'>
      <TweenOne key='text-container' component={Container} {...FadeIn}>
          <div className='h2'>
              Galleon supports all major carriers
          </div>
          <div className='h2 text-blue'>
              And we&rsquo;re always adding more.
          </div>
      </TweenOne>
      <TweenOne key='carriers-carousel-container'
                component={Container}
                styleName='carriers-carousel-container'
                {...FadeUp}>
          <CarriersCarousel />
          <ButtonLink to='/features/carrier-agnostic'>
              View all supported carriers
          </ButtonLink>
      </TweenOne>
      <TweenOne key='disclaimer-container'
                component={Container}
                styleName='disclaimer-container'
                {...FadeUp}>
          <p>
              All company logos above are trademarks (&trade;) or registered
              trademarks (&reg;) of their respective holders.
          </p>
          <p>
              Use of these logos does not imply any affiliation with or
              endorsement by them.
          </p>
      </TweenOne>
  </ScrollOverPack>
);



// WEBPACK FOOTER //
// ./src/components/CarriersCarouselSection.js